/* Bauble add-on for the product page: pick baubles in a popup (same build-your-
   collection logic + $5-off-each bundle), then "Add all to cart" adds the chosen
   baubles AND the current product (its selected variant + quantity) in one call. */
(function () {
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function truncate(s, n) { s = String(s || ''); return s.length > n ? s.slice(0, n).replace(/\s+\S*$/, '') + '…' : s; }
  function imgSrc(p) {
    var im = p.images && p.images[0];
    var src = im ? (im.src || im) : (p.featured_image || '');
    return src && src.indexOf('//') === 0 ? 'https:' + src : src;
  }

  function init(addon) {
    if (addon.dataset.wired) return;
    addon.dataset.wired = '1';

    var cfg = {
      handle: addon.getAttribute('data-bauble-collection') || 'baubles',
      perBox: parseInt(addon.getAttribute('data-per-box'), 10) || 6,
      min: parseInt(addon.getAttribute('data-bundle-min'), 10) || 0,
      off: parseInt(addon.getAttribute('data-bundle-off'), 10) || 0,
      label: addon.getAttribute('data-bundle-label') || 'Baubles Bundles',
      addMain: addon.getAttribute('data-add-main') !== 'false'
    };

    var modal = addon.querySelector('[data-ba-modal]');
    var grid = addon.querySelector('[data-ba-grid]');
    var totalEl = addon.querySelector('[data-ba-total]');
    var wasEl = addon.querySelector('[data-ba-was]');
    var saveEl = addon.querySelector('[data-ba-save]');
    var countEl = addon.querySelector('[data-ba-count]');
    var doneEl = addon.querySelector('[data-ba-done]');
    var closeEl = addon.querySelector('[data-ba-close]');
    var chosen = addon.querySelector('[data-ba-chosen]');
    var rail = addon.querySelector('[data-ba-rail]');
    var emptyBtn = addon.querySelector('[data-ba-empty]');
    var emptyText = addon.querySelector('[data-ba-empty-text]');
    var addAll = addon.querySelector('[data-ba-addall]');
    var msgEl = addon.querySelector('[data-ba-msg]');

    var moneyZero = totalEl ? totalEl.textContent.trim() : '$0.00';
    function money(cents) {
      if (/[0-9]/.test(moneyZero)) return moneyZero.replace(/[\d.,]+/, (cents / 100).toFixed(2));
      try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'AUD' }).format(cents / 100); }
      catch (e) { return '$' + (cents / 100).toFixed(2); }
    }

    var state = {}; // variantId -> { qty, price, title, image }
    var loaded = false;

    function info() {
      var subtotal = 0, boxes = 0;
      Object.keys(state).forEach(function (id) { subtotal += state[id].qty * state[id].price; boxes += state[id].qty; });
      var discount = (cfg.off > 0 && boxes >= cfg.min) ? boxes * cfg.off : 0;
      return { subtotal: subtotal, discount: discount, payable: subtotal - discount, boxes: boxes };
    }

    function renderPickerTotals() {
      var i = info();
      if (totalEl) totalEl.textContent = money(i.payable);
      if (wasEl) { if (i.discount > 0) { wasEl.hidden = false; wasEl.textContent = money(i.subtotal); } else wasEl.hidden = true; }
      if (saveEl) {
        if (i.discount > 0) { saveEl.hidden = false; saveEl.textContent = '★ ' + cfg.label + ' − ' + money(i.discount); }
        else if (cfg.off > 0 && i.boxes > 0 && i.boxes < cfg.min) {
          saveEl.hidden = false;
          var need = cfg.min - i.boxes;
          saveEl.textContent = 'Add ' + need + ' more ' + (need === 1 ? 'box' : 'boxes') + ' to save ' + money(cfg.off) + ' each';
        } else saveEl.hidden = true;
      }
      if (countEl) {
        var n = i.boxes * cfg.perBox;
        countEl.textContent = i.boxes === 0 ? 'No baubles selected yet'
          : i.boxes + (i.boxes === 1 ? ' box, ' : ' boxes, ') + n + (n === 1 ? ' bauble' : ' baubles');
      }
    }

    function syncCard(id) {
      var card = grid.querySelector('[data-ba-card][data-id="' + id + '"]');
      if (!card) return;
      var q = (state[id] && state[id].qty) || 0;
      var c = card.querySelector('[data-ba-cardcount]');
      var badge = card.querySelector('.bpcard__badge');
      var minus = card.querySelector('[data-ba-step="-1"]');
      if (c) c.textContent = q;
      if (badge) badge.textContent = q;
      card.classList.toggle('is-selected', q > 0);
      if (minus) minus.disabled = q === 0;
    }

    function change(id, delta) {
      var s = state[id];
      if (!s) return;
      s.qty = Math.max(0, s.qty + delta);
      syncCard(id);
      renderPickerTotals();
      renderChosen();
      updateAddAll();
    }

    function renderGrid(products) {
      grid.innerHTML = products.map(function (p) {
        var v = (p.variants && p.variants[0]) || {};
        var id = v.id;
        var available = v.available !== false;
        var priceCents = Math.round(parseFloat(v.price || '0') * 100);
        var src = imgSrc(p);
        if (id && !state[id]) state[id] = { qty: 0, price: priceCents, title: p.title, image: src };
        var tag = available ? ''
                            : '<span class="bpcard__tag bpcard__tag--soldout">Sold out</span>';
        var controls = available
          ? '<div class="bpcard__qty">' +
              '<button type="button" class="bpcard__btn" data-ba-step="-1" aria-label="Remove one" disabled>&minus;</button>' +
              '<span class="bpcard__count" data-ba-cardcount>0</span>' +
              '<button type="button" class="bpcard__btn" data-ba-step="1" aria-label="Add one">&plus;</button>' +
            '</div>'
          : '<div class="bpcard__soldnote">Currently unavailable</div>';
        return '<div class="bpcard' + (available ? '' : ' is-soldout') + '" data-ba-card data-id="' + (id || '') + '">' +
          '<div style="position:relative">' + tag + '<span class="bpcard__badge">0</span>' +
          (src ? '<img class="bpcard__img" src="' + escapeHtml(src) + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' : '<div class="bpcard__img"></div>') +
          '</div>' +
          '<div class="bpcard__body">' +
            '<div class="bpcard__name">' + escapeHtml(truncate(p.title, 48)) + '</div>' +
            '<div class="bpcard__price">' + money(priceCents) + '</div>' + controls +
          '</div></div>';
      }).join('');

      grid.querySelectorAll('[data-ba-card]').forEach(function (card) {
        var id = card.getAttribute('data-id');
        if (!id) return;
        card.querySelectorAll('[data-ba-step]').forEach(function (btn) {
          btn.addEventListener('click', function () { change(id, parseInt(btn.getAttribute('data-ba-step'), 10) || 0); });
        });
        syncCard(id);
      });
      renderPickerTotals();
    }

    function load() {
      if (loaded) return;
      loaded = true;
      fetch(root() + 'collections/' + cfg.handle + '/products.json?limit=250', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (data) { renderGrid((data && data.products) || []); })
        .catch(function () { if (grid) grid.innerHTML = '<div class="bpicker__loading">Sorry — baubles could not be loaded.</div>'; loaded = false; });
    }

    // ----- Rail (chosen chips) -----
    // The product column is max-content sized, so the chip row would stretch it
    // instead of scrolling. Collapse the track to measure the column's natural
    // (no-chips) width, then cap the track to it so it scrolls within the column.
    function fitRail() {
      if (!chosen || !rail || rail.hidden) return;
      chosen.style.maxWidth = '0px';
      var w = addon.clientWidth; // addon is a block → its natural column width
      chosen.style.maxWidth = w > 40 ? w + 'px' : '100%';
    }

    function railUpdate() {
      if (!rail) return;
      var track = rail.querySelector('[data-ba-track]');
      var prev = rail.querySelector('[data-ba-prev]');
      var next = rail.querySelector('[data-ba-next]');
      if (!track) return;
      var kids = track.children;
      var noOverflow = track.scrollWidth <= track.clientWidth + 2;
      if (!kids.length || noOverflow) { if (prev) prev.disabled = true; if (next) next.disabled = true; return; }
      var t = track.getBoundingClientRect(), f = kids[0].getBoundingClientRect(), l = kids[kids.length - 1].getBoundingClientRect();
      if (prev) prev.disabled = f.left >= t.left - 6;
      if (next) next.disabled = l.right <= t.right + 6;
    }

    function renderChosen() {
      if (!chosen) return;
      var ids = Object.keys(state).filter(function (id) { return state[id].qty > 0; });
      if (emptyText) {
        emptyText.textContent = ids.length
          ? (emptyBtn.getAttribute('data-label-more') || 'Add more baubles')
          : (emptyBtn.getAttribute('data-label-empty') || emptyText.textContent);
      }
      if (!ids.length) { if (rail) rail.hidden = true; chosen.innerHTML = ''; return; }
      if (rail) rail.hidden = false;
      chosen.innerHTML = ids.map(function (id) {
        var s = state[id];
        return '<div class="ba-chip" data-ba-chip data-id="' + id + '">' +
          (s.image ? '<img class="ba-chip__img" src="' + escapeHtml(s.image) + '" alt="" loading="lazy">' : '<div class="ba-chip__img"></div>') +
          '<div class="ba-chip__name">' + escapeHtml(truncate(s.title, 42)) + '</div>' +
          '<div class="ba-chip__qty">' +
            '<button type="button" class="ba-chip__btn" data-ba-chip-step="-1" aria-label="Remove one">&minus;</button>' +
            '<span class="ba-chip__count">' + s.qty + '</span>' +
            '<button type="button" class="ba-chip__btn" data-ba-chip-step="1" aria-label="Add one">&plus;</button>' +
          '</div></div>';
      }).join('');
      chosen.querySelectorAll('[data-ba-chip]').forEach(function (chip) {
        var id = chip.getAttribute('data-id');
        chip.querySelectorAll('[data-ba-chip-step]').forEach(function (btn) {
          btn.addEventListener('click', function () { change(id, parseInt(btn.getAttribute('data-ba-chip-step'), 10) || 0); });
        });
      });
      window.requestAnimationFrame(function () { fitRail(); railUpdate(); });
    }

    if (rail) {
      var track = rail.querySelector('[data-ba-track]');
      var prevB = rail.querySelector('[data-ba-prev]');
      var nextB = rail.querySelector('[data-ba-next]');
      function step() {
        var card = track.children[0];
        var cs = getComputedStyle(track);
        var gap = parseFloat(cs.columnGap || cs.gap) || 12;
        return card ? card.getBoundingClientRect().width + gap : Math.round(track.clientWidth * 0.8);
      }
      if (prevB) prevB.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (nextB) nextB.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      if (track) track.addEventListener('scroll', function () { window.requestAnimationFrame(railUpdate); }, { passive: true });
      window.addEventListener('resize', function () { fitRail(); railUpdate(); });
    }

    // ----- Add all to cart -----
    function updateAddAll() {
      if (!addAll) return;
      var i = info();
      var base = addAll.getAttribute('data-label') || 'Add to cart';
      addAll.textContent = i.boxes > 0 ? base + ' + ' + i.boxes + (i.boxes === 1 ? ' bauble' : ' baubles') : base;
    }

    function mainProductItem() {
      var form = document.querySelector('product-form-component form') || document.querySelector('form[action*="/cart/add"]');
      if (!form) return null;
      var idEl = form.querySelector('[name="id"]');
      if (!idEl || !idEl.value) return null;
      var qtyEl = form.querySelector('[name="quantity"]');
      var qty = qtyEl ? (parseInt(qtyEl.value, 10) || 1) : 1;
      return { id: Number(idEl.value), quantity: qty };
    }

    function showMsg(text) { if (msgEl) { msgEl.textContent = text; msgEl.hidden = false; } }

    if (addAll) {
      addAll.setAttribute('data-label', addAll.textContent.trim());
      addAll.addEventListener('click', function () {
        var items = [];
        if (cfg.addMain) { var m = mainProductItem(); if (m) items.push(m); }
        Object.keys(state).forEach(function (id) { if (state[id].qty > 0) items.push({ id: Number(id), quantity: state[id].qty }); });
        if (!items.length) return;
        if (msgEl) msgEl.hidden = true;
        addAll.disabled = true;
        var lbl = addAll.textContent;
        addAll.textContent = 'Adding…';
        fetch(root() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
          .then(function (res) {
            if (!res.ok) {
              addAll.disabled = false; addAll.textContent = lbl;
              showMsg((res.d && (res.d.description || res.d.message)) || 'Sorry, these could not be added to the cart.');
              return;
            }
            window.location.href = root().replace(/\/$/, '') + '/cart';
          }).catch(function () { addAll.disabled = false; addAll.textContent = lbl; showMsg('Something went wrong. Please try again.'); });
      });
    }

    // ----- Open / close -----
    function open() { if (modal && typeof modal.showModal === 'function' && !modal.open) modal.showModal(); load(); }
    addon.querySelectorAll('[data-ba-open]').forEach(function (b) { b.addEventListener('click', open); });
    if (doneEl) doneEl.addEventListener('click', function () { if (modal) modal.close(); });
    if (closeEl) closeEl.addEventListener('click', function () { if (modal) modal.close(); });
    if (modal) modal.addEventListener('click', function (e) { if (e.target === modal) modal.close(); });

    renderChosen();
    updateAddAll();
  }

  function boot() { document.querySelectorAll('[data-ba-addon]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
